import eventManagerService from '@/api/eventModule/eventManagerServices'

export default {
  loadTable({ commit }, pageConfig) {
    return new Promise((resolve, reject) => eventManagerService
      .loadTable(pageConfig)
      .then(result => {
        commit('LOAD_LIST_EVENT_MANAGERS', result.data.content)
        resolve(result)
      })
      .catch(err => reject(err)))
  },
  insertNew({ commit }, data) {
    return eventManagerService
      .insertNew(data)
      .then(result => result)
      .catch(error => error)
  },
  prepareToEdit({ commit }, data) {
    commit('PREPARE_TO_EDIT_EVENT_MANAGER', data)
  },
  edit({ commit }, data) {
    return eventManagerService
      .edit(data)
      .then(result => result)
      .catch(error => error)
  },
  reset({ commit }) {
    commit('RESET_EVENT_MANAGER')
  },
  delete({ commit }, id) {
    return eventManagerService
      .delete(id)
      .then(result => result)
      .catch(error => error)
  },
}
